import { oneKlicks } from '../../SDK/oneclick';
import { getuserdata } from '../../services/apiService';
import { debugLog } from '../../utils/debug';


export const getAccountSharing = async (userId) => {
    try {
        const carrountuserid = userId || await getuserdata("id");
        const tableSchema = "";
        const tableName = "account_sharing";
        const conditions = { account_sharing_id: carrountuserid };
        const orderBy = "id DESC";
        const search = {};
        const pagination = { page: 1, limit: 10 };
        const margedata = [];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response', response);
        if (response.success && response.data.length > 0) {
            return response.data;
        } else {
            return [];
        }
    } catch (error) {
        debugLog('getAccountSharing error', error);
        return [];
    }
};

export const handleInvite = async (nameInput, emailInput, setSubmitting, handleGetAccountSharing, setNameInput, setEmailInput, userId) => {
    if (!nameInput.trim()) {
        alert('Please enter the user\'s name.');
        return;
    }
    if (!emailInput || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput)) {
        alert('Please enter a valid email address.');
        return;
    }
    try {
        setSubmitting(true);
        // TODO: Hook up actual invite/create API when available.
        debugLog('Invite clicked', { name: nameInput, email: emailInput });
        const usersTableSchema = "";
        const usersTableName = "users";
        const usersConditions = { "email": emailInput };
        const usersOrderBy = "id DESC";
        const usersSearch = {};
        const usersPagination = {};
        const usersMargedata = [];
        const usersResponse = await oneKlicks.read(
            usersTableSchema,
            usersTableName,
            usersConditions,
            usersOrderBy,
            usersSearch,
            usersPagination,
            usersMargedata
        );
        debugLog('response check email', usersResponse);
        if (usersResponse.success && usersResponse.data.length > 0) {

        } else {
        }
        const shareTableSchema = "";
        const shareTableName = "account_sharing";
        const shareData = {
            account_sharing_id: userId || await getuserdata("id"),
            name: nameInput,
            email: emailInput
        };
        const shareCondition = {
            email: emailInput
        };
        const createResponse = await oneKlicks.create(shareTableSchema, shareTableName, shareData, shareCondition);
        debugLog('create account_sharing', createResponse);
        if (createResponse.success) {
            debugLog('account_sharing created');
            if (setNameInput) setNameInput('');
            if (setEmailInput) setEmailInput('');
            // Optionally refresh list
            handleGetAccountSharing();
            return createResponse.message;
        } else {
            debugLog('account_sharing not created');
            return createResponse.message;
        }
    } catch (error) {
        debugLog('Invite error', error);
    } finally {
        setSubmitting(false);
    }
};
